import type { ReactNode } from 'react';
import React from 'react';
import * as styles from './SquarishCardGrid.module.scss';

interface SquarishCardGridProps {
  children: ReactNode;
}

const SquarishCardGrid = ({ children }: SquarishCardGridProps) => {
  return (
    <div className={styles.container}>
      <ul className={styles.cardGrid}>{children}</ul>
    </div>
  );
};

interface SquarishCardGridItemProps {
  children: ReactNode;
}

SquarishCardGrid.Item = ({ children }: SquarishCardGridItemProps) => {
  return <li>{children}</li>;
};

export default SquarishCardGrid;
